import React from 'react';
import ClassNames from 'classnames';
import Style from './label.module.scss';

export function Label(props){
  const css = ClassNames([

    Style.label,
    props.required && Style.required

  ]);

  return(
    <label 
      className={ css } 
      htmlFor={ props.for } 
      style={{
        color: props.color, 
        textAlign: props.type && (props.type === 'check' || props.type === 'radio') ? 'left' : null, 
        fontWeight: props.weight ? '700' : null}}
    >
      { props.text }
    </label>
  );
}
